import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { summarizeSeats, type SeatCapacity } from "@/lib/learners/seats";

export type LearnerSeatRow = {
  id: string;
  user_id: string | null;
  learner_kind: string;
  provisional_display_name: string | null;
  status: string;
  over_entitlement: boolean;
};

/** Seat occupancy from learner_seats; capacity from max_learners via the server RPC. */
export function useLearnerSeats(householdId: string | null | undefined) {
  return useQuery({
    queryKey: ["learner-seats", householdId ?? "none"],
    enabled: !!householdId,
    staleTime: 10_000,
    queryFn: async () => {
      const [cap, seats] = await Promise.all([
        supabase.rpc("learner_seat_capacity", { p_household_id: householdId! }),
        supabase
          .from("learner_seats")
          .select("id,user_id,learner_kind,provisional_display_name,status,over_entitlement")
          .eq("household_id", householdId!)
          .in("status", ["active", "pending_setup"]),
      ]);
      if (cap.error) throw cap.error;
      if (seats.error) throw seats.error;
      return {
        summary: summarizeSeats(cap.data as unknown as SeatCapacity),
        seats: (seats.data ?? []) as LearnerSeatRow[],
      };
    },
  });
}
